import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function StickyMobileCta() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/apply") || pathname.startsWith("/admin")) return null;
  return (
    <div
      className="lg:hidden fixed bottom-4 left-4 right-4 z-30"
      data-testid="sticky-mobile-cta"
    >
      <Link
        to="/apply"
        className="flex items-center justify-between bg-forest text-white rounded-2xl px-5 py-4 shadow-2xl"
      >
        <span className="font-heading font-semibold text-[15px]">Check my business eligibility</span>
        <span className="grid place-items-center h-9 w-9 rounded-xl bg-bright text-[hsl(150_40%_8%)]">
          <ArrowUpRight size={18} strokeWidth={2.4} />
        </span>
      </Link>
    </div>
  );
}
